import { useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { ChevronDown } from "lucide-react";

const FAMILY = [
  ["🔍", "Tell us who needs care", "Use the search bar or browse by category — or chat with Cara."],
  ["👤", "Browse verified profiles", "Compare credentials, reviews, languages and rates. You pick."],
  ["📅", "Book your slot", "Hourly, full-day or recurring; date, time, duration, shift type."],
  ["💳", "Pay securely", "UPI, Razorpay cards or international card for NRIs. Funds held in escrow."],
  ["📱", "Track every visit", "WhatsApp check-ins, care notes, daily log in your family portal."],
];
const CARER = [
  ["📝", "Register free", "Submit Aadhaar, PAN, qualification documents."],
  ["✅", "Get verified", "AuthBridge credential check, 24–48 hours."],
  ["🌐", "Go live", "Profile published, families can find and book you."],
  ["📲", "Manage bookings", "Check in/out via OTP, complete task checklists."],
  ["💳", "Get paid", "Every Friday via UPI to your bank account."],
];
const FAQ = [
  ["What verification does every carer go through?", "Aadhaar e-KYC via UIDAI, an independent police & background check via AuthBridge/BetterPlace, credential verification against issuing bodies, and a BookMyCarer competency test."],
  ["How quickly can I get a carer?", "Median time to match is under 2 hours in Hyderabad and Bengaluru."],
  ["Can I meet the carer before booking?", "Yes — you can message or request a video call before confirming."],
  ["What if my carer doesn't show up?", "Our Trust Guarantee replaces your carer within 2 hours or refunds you in full."],
  ["How are payments handled?", "Funds are held in escrow and released after the visit is confirmed. UPI, cards or international for NRIs."],
  ["Can I book recurring care?", "Yes — daily, weekly or live-in arrangements are supported."],
  ["I'm an NRI — how do I pay and track care?", "Pay in USD/GBP/AED/SGD by international card, and get WhatsApp updates after every visit in your timezone."],
  ["What is the Trust Guarantee?", "An insurer-backed promise: replacement within 2 hours or a full refund if care falls short of what was agreed."],
];

export default function HowItWorks() {
  const [tab, setTab] = useState("family");
  const [open, setOpen] = useState(0);
  const steps = tab === "family" ? FAMILY : CARER;
  return (
    <PublicLayout>
      <section className="bmc-wrap py-14 text-center">
        <h1 className="text-4xl sm:text-5xl font-extrabold">From need to verified carer in minutes.</h1>
        <div className="inline-flex bg-ivory-2 rounded-full p-1 mt-8">
          {[["family", "For Families"], ["carer", "For Carers"]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`tab-${k}`}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-colors ${tab === k ? "bg-coral text-white" : "text-ink-soft"}`}>{l}</button>
          ))}
        </div>
      </section>

      <section className="bmc-wrap pb-16">
        <div className="grid md:grid-cols-5 gap-4">
          {steps.map(([icon, t, d], i) => (
            <div key={t} className="card-bmc p-5">
              <span className="text-3xl">{icon}</span>
              <p className="text-xs font-bold text-coral mt-3">STEP {i + 1}</p>
              <h3 className="font-display font-bold mt-1">{t}</h3>
              <p className="text-sm text-ink-soft mt-2">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-ivory-2 py-16">
        <div className="bmc-wrap max-w-3xl">
          <h2 className="text-3xl font-bold text-center mb-8">Frequently asked questions</h2>
          <div className="space-y-3">
            {FAQ.map(([q, a], i) => (
              <div key={q} className="card-bmc overflow-hidden">
                <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between p-5 text-left font-semibold" data-testid={`faq-${i}`}>
                  {q} <ChevronDown size={18} className={`transition-transform ${open === i ? "rotate-180" : ""}`} />
                </button>
                {open === i && <div className="px-5 pb-5 text-sm text-ink-soft -mt-1">{a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
